'use strict';

import React from 'react';

import AllocationItem from "../AllocationItem/AllocationItem";


const AllocationList = ({ element, allocations, setAllocations }) => {
  return (
    <table className="AllocationList">
      <tbody>
        {allocations.length > 0 && 
          <tr>
            <th>Starting</th>
            <th>Ending</th>
            <th className='hideOnMobile'>From</th>
            <th className='hideOnMobile'>To</th>
            <th className='hideOnMobile'>Repeats</th>
          </tr>
        }
        { allocations.map((allocation, idx) => 
          <AllocationItem
            key={idx}
            element={element}
            allocation={allocation}
            allocations={allocations}
            setAllocations={setAllocations}
          />
        )}
      </tbody>
    </table>
  )
};

export default AllocationList;
